module.exports = __webpack_public_path__ + "img/IL.96f18d04.svg";